import React from "react";
import PropTypes from "prop-types";
import { Checkbox } from 'semantic-ui-react';

const IsActiveColumn = ({row}) => {
    return <Checkbox checked={row.IsActive} disabled />;
};

IsActiveColumn.propTypes = {
    row: PropTypes.shape({
        IsActive: PropTypes.bool.isRequired,
    }).isRequired,
}

export default IsActiveColumn;